<template>
  <div class="has-logo">
    <logo :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="false"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.has-logo {
  background: #fff;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
  width: 220px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  transition: all 0.3s cubic-bezier(0.4,0,0.2,1);
  z-index: 20;
}

.scrollbar-wrapper {
  padding-top: 0;
  padding-bottom: 0;
}

.el-menu {
  border: none;
  background: transparent;
  .el-menu-item {
    height: 44px;
    line-height: 44px;
    padding: 0 20px 0 20px !important;
    border-radius: 8px;
    margin: 4px 8px;
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #7b8190;
    background: transparent !important;
    position: relative;
    transition: background 0.2s, color 0.2s;
    .svg-icon {
      font-size: 20px;
      margin-right: 14px;
      color: #b0b8c9;
      transition: color 0.2s;
    }
  }
  .el-menu-item.is-active {
    background: #f5faff !important;
    color: $primary !important;
    font-weight: 600;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 8px;
      bottom: 8px;
      width: 4px;
      border-radius: 4px;
      background: $primary;
    }
    .svg-icon {
      color: $primary !important;
    }
  }
  .el-menu-item:not(.is-active):hover {
    background: #f5f7fa !important;
    color: #222;
    .svg-icon {
      color: #7b8190;
    }
  }
}
</style>
